@let selectedLanguageValue = selectedLanguage();
@let i18nPrefixValue = i18nPrefix();
@let form = parentForm();
@let controls = form.controls;
@let i18nCtaValidatorPrefix = `${i18nPrefixValue}.VALIDATORS.CTA_BOTH_OR_NONE_REQUIRED`;

<div *transloco="let t; prefix: i18nPrefixValue" class="flex flex-col gap-3" [formGroup]="form">
  <mat-form-field class="w-full">
    <mat-label>{{ t(selectedLanguageValue === 'hu' ? 'LABELS_HU' : 'LABELS_EN') }}</mat-label>
    <mat-chip-grid
      #reactiveChipGrid
      aria-label="Enter reactive form keywords"
      formControlName="labels"
    >
      @for (keyword of controls.labels.value; track keyword) {
        <mat-chip-row (removed)="removeReactiveKeyword(keyword)">
          {{ keyword }}
          <button matChipRemove type="button">
            <mat-icon customMatSvgIcon="pct-mdi-delete" />
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      #labelsInput
      [matChipInputAddOnBlur]="true"
      [matChipInputFor]="reactiveChipGrid"
      [name]="'labels' | withLang: selectedLanguageValue"
      (matChipInputTokenEnd)="addReactiveKeyword($event)" />
    <mat-error [control]="controls.labels"
  /></mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{ selectedLanguageValue === 'hu' ? t('CTA_HU') : t('CTA_EN') }}</mat-label>
    <input
      formControlName="ctaText"
      matInput
      type="text"
      [name]="'cta-text' | withLang: selectedLanguageValue"
    />
    <mat-error
      [control]="controls.ctaText"
      [overrideErrors]="{ bothOrNoneRequired: i18nCtaValidatorPrefix + '.CTA' }"
    />
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{ selectedLanguageValue === 'hu' ? t('CTA_URL_HU') : t('CTA_URL_EN') }}</mat-label>
    <input
      formControlName="ctaUrl"
      matInput
      type="url"
      [name]="'cta-url' | withLang: selectedLanguageValue"
    />
    <mat-error
      [control]="controls.ctaUrl"
      [overrideErrors]="{ bothOrNoneRequired: i18nCtaValidatorPrefix + '.CTA_URL' }"
    />
  </mat-form-field>
</div>
